module.exports = {
    ctaButtonTypes: {
        downloadButtons: {
            download: 'Download',
            getTempest: 'Get Tempest',
        },
    },
};
